export default function NoticesEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-SOI-Consulting-Eng-Services-MTF-Grant-deadline-oct27.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;PA DOT MTF Grant Project - SOI for Consulting Engineering Services<br/>DEADLINE 10/27/2026 at 11:00AM
            </a>
        </td>
        <td>10/13/2026</td>
      </tr>
      {/*End File*/}
        {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-floodplain-notice-july-13-2026-1.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;Floodplain Notice
            </a>
        </td>
        <td>7/14/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-additonal-library-board-meeting-may-11-2026.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;Addiontal Library Board Meeting 5/11/26
            </a>
        </td>
        <td>4/21/2026</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-MMA-Spring-Flushing-Notice.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;MMA Spring Water Main Flushing Schedule
            </a>
        </td>
        <td>4/8/2026</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-new-trash-recycling-containers.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;New Trash &amp; Recycling Containers
            </a>
        </td>
        <td>3/18/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-SOI-Consulting-Eng-Services-MTF-Grant.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;PA DOT MTF Grant Project - SOI for Consulting Engineering Services
            </a>
        </td>
        <td>3/16/2026</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-library-meeting-schedule.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;2026 Library Meeting Schedule
            </a>
        </td>
        <td>12/18/2025</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-public-meeting-schedule.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;2026 Public Meeting Schedule
            </a>
        </td>
        <td>12/18/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-library-closures.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;2026 Library Closures
            </a>
        </td>
        <td>12/18/2025</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2026-municipal-office-closures.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;2026 Municipal Office Closures
            </a>
        </td>
        <td>12/18/2025</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2025-CSC-Agenda-Sept-15.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;9/15/25 - CSC Meeting Agenda
            </a>
        </td>
        <td>09/12/2025</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2025-pool-draining.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;PSA - Pool Draining Restrictions
            </a>
        </td>
        <td>09/03/2025</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2025-PaDEP-act-537-submission-of-plan-update-revision.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;PaDEP Act 537 required notice of plan update revision submission being prepared
            </a>
        </td>
        <td>08/06/2025</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/notice/notice-2025-trash-collection-services-bid-docs-revised-20250905.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;Trash Collection Services Bid Documents - Revised 9/5/25
            </a>
        </td>
        <td>09/05/2025</td>
      </tr>
      {/*End File*/}
       
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/notice/notice-2025-MMA-Flushing-April.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;MMA Water Main Flushing - April 2025
          </a>
        </td>
        <td>04/14/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/notice/notice-2025-PECO-VegMgt-Map.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;PECO Spring Vegetation Mgmt. Map
          </a>
        </td>
        <td>03/31/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/notice/notice-2025-jdm-RCO-documentation.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2025 Road Program RCO Documents
          </a>
        </td>
        <td>01/08/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/info/2025-MB-Meeting-Schedule.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2025 Meeting Schedule
          </a>
        </td>
        <td>01/08/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/notice/notice-2024-leaf-dropoff.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2024 Leaf Drop-off
          </a>
        </td>
        <td>11/01/2024</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
